import produce, {Draft} from 'immer';
import {handleActions} from 'redux-actions';
import {Reducer} from 'redux';
import {ActionType} from 'redux-promise-middleware';

import actions from '../actions';
import initialState from '../store/initialState';

const reducer: Reducer<MeStore, any> = handleActions(
  {
    [`${actions.me.updateMe}_${ActionType.Fulfilled}`](
      state: MeStore,
      action: any
    ) {
      const newState = produce(state, (draftState: Draft<MeStore>) => {
        draftState.id = action.payload.me.id;
        draftState.sub = action.payload.me.sub;
        draftState.lastName = action.payload.me.lastName;
        draftState.firstName = action.payload.me.firstName;
        draftState.lastKana = action.payload.me.lastKana;
        draftState.firstKana = action.payload.me.firstKana;
        draftState.prefecture = action.payload.me.prefecture;
        draftState.email = action.payload.me.email;
        draftState.authLevel = action.payload.me.authLevel;
        draftState.phoneNumber = action.payload.me.phoneNumber;
        draftState.teamId = action.payload.me.teamId;
        draftState.customerId = action.payload.me.customerId;
        draftState.intensity = action.payload.me.intensity;
        draftState.isOptioned = action.payload.me.isOptioned;
        draftState.plan = action.payload.me.plan;
        draftState.birthdate = action.payload.me.birthdate;
        draftState.organization = action.payload.me.organization;
        draftState.position = action.payload.me.position;
        draftState.gender = action.payload.me.gender;
        draftState.provider = action.payload.me.provider;
        draftState.isForceCanceled = action.payload.me.isForceCanceled;
      });

      return newState;
    },
  },
  initialState.me
);

export default reducer;
